import { Form, Formik } from 'formik';
import { ReactElement, useState } from 'react';
import { ValueRanges } from 'rlv-common';
import { isDivergingInsuredPerson } from '../../../../Helper';
import AemFragment from '../../../../components/AemFragment/AemFragment';
import Footer from '../../../../components/Footer';
import FieldDateInputRow from '../../../../components/FormComponents/FieldDateInputRow/FieldDateInputRow';
import { Headline } from '../../../../components/Headline/Headline';
import InfoText from '../../../../components/InfoText/infoText';
import { NavigationAction } from '../../../../routing/StateMachineTypes';
import { AemFragmentCatalog } from '../../../../types/AemFragmentCatalog';
import { SharedSubmitCallBack } from '../../../../types/callbacks/sharedSubmitCallBack';
import { createLivingConditionsBirthdateSchema } from '../../../../validation/LivingConditionsPage';

interface BirthdateFormProps extends SharedSubmitCallBack<string> {
  birthdate?: string;
  disabled: boolean;
  valueRanges: ValueRanges;
  onNavigateNoSubmit: (navigationRequest: NavigationAction) => void;
  onSubmit: (value: string, navigationRequest: NavigationAction) => void;
  updateTrackingBirthdate: (date: string) => void;
}

const BirthdateForm = ({
  birthdate,
  valueRanges,
  onNavigateNoSubmit,
  onSubmit,
}: BirthdateFormProps): ReactElement => {
  const [navigationRequest, setNavigationRequest] = useState(NavigationAction.NEXT);

  const headlineText = isDivergingInsuredPerson()
    ? 'Geben Sie das Geburtsdatum der zu versichernden Person an'
    : 'Geben Sie Ihr Geburtsdatum an';

  const footerInfoSection = (
    <InfoText textBeforeLink="Wenn Sie jemand anders absichern möchten, geben Sie bitte dessen Geburtsdatum an."></InfoText>
  );

  return (
    <>
      <Formik
        initialValues={{ birthdate, valueRanges }}
        onSubmit={values => onSubmit(values.birthdate || '', navigationRequest)}
        validationSchema={createLivingConditionsBirthdateSchema(valueRanges)}
      >
        {form => (
          <Form className="birthdate-form__body">
            <Headline text={headlineText} />
            <FieldDateInputRow
              name="birthdate"
              date={birthdate}
              label={''}
              formError={form.errors.birthdate}
              onError={(error: string | undefined) => {
                form.setStatus(error);
              }}
            />
            <AemFragment name={AemFragmentCatalog.STEP3VA} useVA={true} />
            <Footer
              showNext
              showPrevious
              labelNext={'weiter'}
              labelPrevious={'zurück'}
              infoSection={footerInfoSection}
              disableNext={!!form.status || !!form.errors.birthdate || !form.values.birthdate}
              handleAction={(navigationAction: NavigationAction) => {
                setNavigationRequest(navigationAction);
                if (navigationAction === NavigationAction.BACK) {
                  onNavigateNoSubmit(navigationAction);
                } else {
                  form.submitForm();
                }
              }}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default BirthdateForm;
